import moment from 'moment';
import { Model, Attr, HasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import Extra from './Extra';

@Model()
export default class BlockoutPeriod extends ApplicationRecord {
  static jsonapiType = 'blockout-periods';

  static supportedBlockTypes = [
    {
      name: 'Block Parking',
      description: 'Bookings with either a drop-off or pick-up that fall within the block-out period will not be allowed',
      value: 'parking',
    },
    {
      name: 'Block Online Form',
      description: 'Online booking form will not be accessible by the public during the block-out period',
      value: 'online_form',
    },
    {
      name: 'Block Extra',
      description: 'Extra will not be available for booking during the block-out period',
      value: 'extra',
    }
  ];

  static listHeaders() {
    return [
      {
        text: 'Name',
        value: 'name',
        width: 100,
        sortable: true,
      },
      {
        text: 'Start',
        value: 'startDatetime',
        sortable: true,
      },
      {
        text: 'End',
        value: 'endDatetime',
        sortable: true,
      },
      {
        text: 'Type',
        value: 'blockType',
        sortable: true,
      },
    ];
  }


  static scopeFactory() {
    return BlockoutPeriod.includes([]);
  }

  @Attr() name: string;
  @Attr() startDatetime: string;
  @Attr() endDatetime: string;
  @Attr() message: string;
  @Attr() blockType: string;
  @HasMany() extras: Extra[];

  get startFormatted() {
    return moment(this.startDatetime).format('DD/MM/YYYY HH:mm');
  }

  get endFormatted() {
    return moment(this.endDatetime).format('DD/MM/YYYY HH:mm');
  }

  get blockTypeDetail() {
    return BlockoutPeriod.supportedBlockTypes.find((t) => t.value === this.blockType) || null;
  }
}
